<template>
    <button
        class="border text-stone-100 p-2 uppercase w-full text-2xl px-4 whitespace-nowrap"
        :class="[
            tourClass,
            {
                'bg-black border-black': brand === 'pelican' && !disabled,
                'bg-blue-500 border-blue-500': brand === 'hydration' && !disabled,
                'bg-gray-300 border-gray-300': disabled,
            }
        ]"
        @click="$emit('click', $event)"
        :disabled="disabled"
    >
        <slot/>
    </button>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'PrimaryButton',

        props: {
            tourClass: String,

            disabled: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            ...mapState({
                brand: (state) => state.customizer.viewController?.blueprint?.custom['v-logo-type'],
            }),
        },
    };
</script>
